export function validateCNPJ(cnpj: string) {
  const cutCnpj = cnpj.split('.');
  const cutCnpjPenulimatePart = cutCnpj[2].split('/');

  const cutCnpjLastPart = cutCnpjPenulimatePart[1].split('-');

  const joinCnpj =
    cutCnpj[0] +
    cutCnpj[1] +
    cutCnpjPenulimatePart[0] +
    cutCnpjLastPart[0] +
    cutCnpjLastPart[1];

  if (joinCnpj == '') return false;

  if (joinCnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    joinCnpj == '00000000000000' ||
    joinCnpj == '11111111111111' ||
    joinCnpj == '22222222222222' ||
    joinCnpj == '33333333333333' ||
    joinCnpj == '44444444444444' ||
    joinCnpj == '55555555555555' ||
    joinCnpj == '66666666666666' ||
    joinCnpj == '77777777777777' ||
    joinCnpj == '88888888888888' ||
    joinCnpj == '99999999999999'
  )
    return false;

  // Valida DVs
  let tamanho: any = joinCnpj.length - 2;
  let numeros: any = joinCnpj.substring(0, tamanho);
  const digitos: any = joinCnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  let i;
  let resultado;

  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) {
    return false;
  }

  tamanho = tamanho + 1;
  numeros = joinCnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) {
    return false;
  } else {
    return true;
  }

  //fonte: https://www.geradorcnpj.com/javascript-validar-cnpj.htm
}

export function validateCPF(cpf: string) {
  //separa o CPF pelos pontos
  const cutCPF = cpf.split('.');
  //pega a parte que tem o - e salva numa variavel
  const cpfLastPart = cutCPF[2];
  //separa a parte que tem o -
  const cutCpfLastPart = cpfLastPart.split('-');
  //junta tudo numa const só
  const cpfJoin = cutCPF[0] + cutCPF[1] + cutCpfLastPart[0] + cutCpfLastPart[1];

  let Soma;
  let Resto;
  let i;
  Resto = 0;
  Soma = 0;

  if (
    cpfJoin == '00000000000' ||
    cpfJoin == '11111111111' ||
    cpfJoin == '22222222222' ||
    cpfJoin == '33333333333' ||
    cpfJoin == '44444444444' ||
    cpfJoin == '55555555555' ||
    cpfJoin == '66666666666' ||
    cpfJoin == '77777777777' ||
    cpfJoin == '88888888888' ||
    cpfJoin == '99999999999'
  ) {
    return false;
  }

  for (i = 1; i <= 9; i++)
    Soma = Soma + parseInt(cpfJoin.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(cpfJoin.substring(9, 10))) {
    return false;
  }

  Soma = 0;
  for (i = 1; i <= 10; i++)
    Soma = Soma + parseInt(cpfJoin.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(cpfJoin.substring(10, 11))) {
    return false;
  } else {
    return true;
  }

  //fonte https://ogeradordecpf.com.br/validar-javascript/
}
